// Curated, hardcoded events shown on /events alongside AI-published rows.
// Edit this file to add, remove, or fix curated event entries.

export interface CuratedEvent {
  month: string; // 3-letter uppercase, e.g. "MAY"
  day: string; // 2-digit string, e.g. "10"
  title: string;
  location: string;
  time: string;
  description: string;
  category: string;
  link: string;
}

// Curated events have been migrated into the published_events database table
// so they can be edited and deleted from the admin UI. New events should be
// added through Admin → Published events, not here.
export const curatedEvents: CuratedEvent[] = [];

const MONTH_CODES = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export const computeCuratedSortDate = (monthCode: string, dayStr: string): Date => {
  const mIdx = MONTH_CODES.indexOf(monthCode.toUpperCase());
  const day = parseInt(dayStr, 10);
  if (mIdx < 0 || isNaN(day)) return new Date(8640000000000000);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const year = today.getFullYear();
  let candidate = new Date(year, mIdx, day);
  if (candidate < today) candidate = new Date(year + 1, mIdx, day);
  return candidate;
};
